import {styled, TableCell} from "@mui/material";

export const EllipsisTableCell = styled(TableCell, {
    shouldForwardProp: (prop) => prop !== 'maxWidth'
})<{ maxWidth?: string }>(({maxWidth}) => ({
    maxWidth: maxWidth || '200px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
}));